import {Component, createRef} from "preact";
import JsonApiDeserializer from "../../../services/JsonApiDeserializer";
import ScrollableSection from "../../layout/scrollable-section";
import Toolbar from "../../layout/toolbar";
import SectionComponent from "../../layout/section-component";
import BackdropCover from "../backdrop-cover";
import Spinner from "../spinner";
import EmptyState from "../empty-state";
import Text from "../text";
import ErrorState from "../error-state";
import ToolbarButton from "../toolbar-button";

export default class InfiniteScrollList extends Component {

    scrollRef = createRef();

    emptyStateMessage = 'list.empty';

    constructor(props) {
        super(props);

        this.state = {
            list: [],
            loadingPrev: false,
            errorPrev: true,
            loadingNext: false,
            errorNext: true,
            reachedLimit: false,
        };
    }

    render(props, state, context) {
        const spinner = (
            <Toolbar>
                <SectionComponent style={{flexGrow: 2}}>
                    <BackdropCover><Spinner/></BackdropCover>
                </SectionComponent>
            </Toolbar>
        );

        const emptyState = (
            <EmptyState>
                <Text text={this.emptyStateMessage}/>
            </EmptyState>
        );

        const errorState = (
            <ErrorState>
                <Text text={'error.loading'}/>
                <ToolbarButton type={'primary fill'} style={{marginTop: '1em'}} onClick={this.getNext}>
                    <Text text={'action.retry'}/>
                </ToolbarButton>
            </ErrorState>
        );

        return (
            <ScrollableSection onAreaChange={this.onAreaChange}>
                <div ref={this.scrollRef}>
                    {(!state.loadingNext && !state.list.length && !state.errorNext) ? emptyState : null}
                    {state.list.map(i => this.renderItem(i))}
                    {this.state.loadingNext ? spinner : null}
                    {(!state.loadingNext && state.errorNext) ? errorState : null}
                </div>
            </ScrollableSection>
        );
    }

    renderItem = (i) => (<div>{i}</div>);

    getPrevRequest = () => new Promise(() => {});

    getNextRequest = () => new Promise(() => {});

    getRefreshRequest = () => new Promise(() => {});

    getPrev = () => {
        this.setState({loadingPrev: true, errorPrev: false});

        return this.getPrevRequest()
            .then((res) => {
                const items = JsonApiDeserializer.deserializeItems(res.data, res['included']);
                const list = this.state.list;
                list.unshift(...items);
                this.setState({loadingPrev: false, list});
            })
            .catch(e => {
                console.error(e);
                this.setState({loadingPrev: false, errorPrev: true});
            });
    };

    getNext = () => {
        if (this.state.reachedLimit) return;

        this.setState({loadingNext: true, errorNext: false});

        return this.getNextRequest()
            .then((res) => {
                const items = JsonApiDeserializer.deserializeItems(res.data, res['included']);
                const list = this.state.list;
                list.push(...items);
                this.setState({
                    loadingNext: false,
                    list,
                    reachedLimit: res.meta['pagination']['total_pages'] === res.meta['pagination']['current_page']
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({errorNext: true, loadingNext: false});
            });
    };

    refresh = () => {
        return this.getRefreshRequest()
            .then((res) => {
                const items = JsonApiDeserializer.deserializeItems(res.data, res['included']);
                this.setState({
                    loadingPrev: false,
                    list: items,
                    reachedLimit: res.meta['pagination']['total_pages'] === res.meta['pagination']['current_page']
                });
            })
            .catch(e => {
                console.error(e);
            });
    };

    onAreaChange = (area) => {
        if (area === 'bottom' && !this.state.loadingNext) {
            this.getNext();
        }
    };

}


// WEBPACK FOOTER //
// ./components/common/infinite-scroll-list/index.js